import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">更新动态</h2>
          <p className="mt-1 text-sm text-foreground-500">漫画连载、新作首发、平台资讯一手掌握</p>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200">
          <div className="flex flex-col gap-5 md:gap-6">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pl-6 md:pl-8 group cursor-pointer">
                <div className="absolute -left-[27px] md:-left-[33px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 ring-2 ring-primary-200 group-hover:ring-primary-400 transition-all"></div>
                <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 group-hover:border-primary-200 transition-all duration-200">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-1">
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap w-fit">{item.tag}</span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}